import { render, staticRenderFns } from "./BaseNotification.vue?vue&type=template&id=79eff216"
import script from "./BaseNotification.vue?vue&type=script&lang=js"
export * from "./BaseNotification.vue?vue&type=script&lang=js"
import style0 from "./BaseNotification.vue?vue&type=style&index=0&id=79eff216&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports